import { render } from "./EquipesPage.vue?vue&type=template&id=2bfbcb62"
import script from "./EquipesPage.vue?vue&type=script&lang=js"
export * from "./EquipesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__